import type { ActionLogEntry } from '@tailorcast/shared-types';

interface ActionDiffPreviewProps {
  action: ActionLogEntry;
}

export function ActionDiffPreview({ action }: ActionDiffPreviewProps) {
  const beforeEntries = Object.entries(action.stateBefore);
  const afterEntries = Object.entries(action.stateAfter);

  if (beforeEntries.length === 0 && afterEntries.length === 0) {
    return null;
  }

  return (
    <div className="text-xs space-y-1 mt-2">
      {beforeEntries.map(([key, val]) => (
        <div key={`before-${key}`} className="text-red-600 bg-red-50 p-1.5 rounded line-through">
          {key}: {String(val)}
        </div>
      ))}
      {afterEntries.map(([key, val]) => (
        <div key={`after-${key}`} className="text-green-600 bg-green-50 p-1.5 rounded">
          {key}: {String(val)}
        </div>
      ))}
    </div>
  );
}
